export type LockerPositionStatus = {
  id: number;
  code: string;
  name: string;
};
export enum LockerColumnStatuses {
  FREE = 'Libre',
  OCCUPIED = 'Ocupado',
  DAMAGED = 'Dañado',
  BLOCKED = 'Bloqueado',
}
